import React from 'react';
import { useAuth } from './session'; // <-- changed
import type { Role } from './roles';

interface Props {
  roles: Role[];
  whenAllowed: React.ComponentType<any>;
  whenDenied:  React.ComponentType<any>;
}

export default function RoleSwitch({ roles, whenAllowed: Allowed, whenDenied: Denied }: Props) {
  const { roles: have } = useAuth();
  const ok = roles.some(r => have.includes(r));
  const Component = ok ? Allowed : Denied;
  return <Component />;
}